import React from 'react'
import Backend from './Backend'
import Frontend from './Frontend'
import './skills.css'
import { useInView } from 'react-intersection-observer'
import { useEffect } from 'react'

const Skills = () => {

    const { ref , inView } = useInView({threshold : 0.3});

    useEffect(()=>{
        if (inView) {
            document.querySelector(".skills__section__title").style.transform = "translateX(0px)"
            document.querySelector(".skills__section__title").style.opacity = 1
            document.querySelector(".skills__section__subtitle").style.transform = "translateX(0px)"
            document.querySelector(".skills__section__subtitle").style.opacity = 1
        }
        else {
            document.querySelector(".skills__section__title").style.transform = "translateX(150px)"
            document.querySelector(".skills__section__title").style.opacity = 0
            document.querySelector(".skills__section__subtitle").style.transform = "translateX(-150px)"
            document.querySelector(".skills__section__subtitle").style.opacity = 0
        }


    },[inView])

    return (
        <section  className="skills section" id="skills">
            <h2 ref={ref} className="section__title skills__section__title">
                Skills
            </h2>
            <span  ref={ref} className="section__subtitle skills__section__subtitle">My technical level</span>


            <div className="skills__container container grid">
                <Frontend/>

                <Backend/>
            </div>
        </section>
    )
}

export default Skills